<template>
    <div class="app" id="app">
        <search-dialog :visible.sync="dialogVisible" :columns="['名称', '编号']" />

        <SearchDrawerMobile :visible.sync="drawerMobile" />

        <SearchDrawerPC :visible.sync="drawerPC" />

        <header>
            <nav class="nav">
                <div class="nav-content">
                    <div class="nav-left">
                        <!-- <div class="nav-avatar">
                            <img src="https://colearn.foxconn.com/files/halo-appendix/%E6%A0%A1%E9%95%BF%E7%85%A7%E7%89%87.png" alt="avatar" />
                        </div> -->
                        <!-- 新增菜单按钮 -->
                        <div class="nav-toggle" @click="menuVisible = !menuVisible">
                            <svg-icon icon-file-name="menu" />
                            <span style="font-size: 1rem;font-weight: 600;margin-left: .5rem"> 菜单 </span>
                        </div>
                    </div>

                    <!-- 导航链接，添加 show 类以控制显示 -->
                    <div class="nav-links" :class="{ show: menuVisible }">
                        <router-link to="/" exact @click.native="menuVisible = false">首页</router-link>
                        <router-link to="/archive" @click.native="menuVisible = false">归档</router-link>
                        <router-link to="/classification" @click.native="menuVisible = false">分类</router-link>
                        <router-link to="/tag" @click.native="menuVisible = false">标签</router-link>
                        <router-link to="/about" @click.native="menuVisible = false">关于</router-link>
                    </div>

                    <div class="nav-right">
                        <!-- <div class="nav-search" @click="dialogVisible = true">
                            <svg-icon icon-file-name="search" />
                        </div> -->
                        <div class="nav-search" @click="openDrawer()">
                            <svg-icon icon-file-name="search" />
                        </div>
                    </div>
                </div>
            </nav>
        </header>

        <main class="main">
            <transition name="slide-up" mode="out-in">
                <router-view />
            </transition>
        </main>

        <footer class="footer">
            <div class="footer-content">
                <p>版权所有：富泰华工业（深圳）有限公司 </p>
                <p>备案号：<a href="https://beian.miit.gov.cn">粤ICP备13021698号</a></p>
            </div>
        </footer>
    </div>
</template>

<script>
import SearchDialog from '@/components/search-dialog/SearchDialog.vue';
import SearchDrawerMobile from '@/components/search-drawer/SearchDrawerMobile.vue';
import SearchDrawerPC from '@/components/search-drawer/SearchDrawerPC.vue';

export default {
    components: {
        SearchDialog,
        SearchDrawerMobile,
        SearchDrawerPC
    },
    name: "App",
    data() {
        return {
            dialogVisible: false,
            drawerPC: false,
            drawerMobile: false,
            menuVisible: false
        };
    },
    methods: {
        // async fetchData(query, page) {
        //     console.log(query, page)
        // },
        // handleSelect(item) {
        //     console.log("选中的数据:", item);
        // }
        openDrawer() {
            if(window.innerWidth <= 768) {
                this.drawerMobile = true
            } else {
                 this.drawerPC = true
            }
        },
    }
};
</script>

<style scoped lang="scss">
/* 其他 SCSS 文件 */
@use './assets/styles/variables' as *;

.app {
    margin: -8px;
    background: #e9e9e9;
    min-height: 100vh;
    height: 100%;
}

nav {
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    height: auto;
    background-color: #f9f9f9;
    box-shadow: 0px 7px 11px rgba(14, 1, 67, 0.1);
}

.nav-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    width: 100%;
    flex-wrap: wrap;
}

.nav-left {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.nav-avatar {
    width: 2.6rem;
    height: 2.6rem;
    overflow: hidden;
    border-radius: 0.41rem;
}

.nav-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.nav-toggle {
    display: none;
    width: 4.1rem;
    height: 2.4rem;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.nav-links {
    display: flex;
    gap: 2rem;
    position: relative;
    font-size: 1.2rem;
}

.nav-links a {
    position: relative;
    padding: 0.5rem 0;
    color: #666;
    text-decoration: none;
    transition: color 0.3s ease;
}

.nav-links a::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background-color: $theme-color;
    transition: width 0.3s ease;
}

.nav-links a:hover::after {
    width: 100%;
}

.nav-links a.router-link-exact-active {
    color: $theme-color;
}

.nav-links a.router-link-exact-active::after {
    width: 100%;
    transition: width 0.3s ease;
}

.nav-right {
    display: flex;
    justify-content: flex-end;
}

.nav-search {
    border-radius: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #cccccc00;
    box-sizing: border-box;
    width: 3.2rem;
    height: 2.2rem;
    background: $theme-color;
    transition: border-color 0.3s ease;
    cursor: pointer;
}



/* 为页面切换添加向上滑动的过渡效果 */
.slide-up-enter-active,
.slide-up-leave-active {
    transition: transform 0.5s ease, opacity 0.5s ease;
}

.slide-up-enter,
.slide-up-leave-to {
    transform: translateY(20px);
    /* 页面从下方滑入 */
    opacity: 0;
}

.slide-up-enter-to,
.slide-up-leave {
    transform: translateY(0);
    /* 页面恢复原位 */
    opacity: 1;
}

.main {
    width: 100%;
    min-height: 100vh;
    overflow: scroll;
    margin: 0;
    padding: 0;
}

/** footer-content */
.footer {
    height: 3.2rem;
    background: $theme-white;
    width: 100%;
    margin-top: 3rem;
}

.footer-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    width: 100%;
    color: #909399;
}

/* 响应式处理 */
@media (max-width: 968px) {
    .nav {
        position: fixed;
        width: 100%;
        z-index: 100;
    }

    .main {
        padding-top: 4.2rem;
    }

    .nav-content {
        flex-wrap: wrap;
        flex-direction: row; // ✅ 不改为 column，保持一行
        align-items: center;
        position: relative; // ✅ 作为绝对定位的参考容器
    }

    .nav-left {
        flex: 1;
    }

    .nav-links {
        width: 100%;
        flex-direction: column;
        display: none;
    }

    .nav-links.show {
        display: flex;
        z-index: 100;
    }

    .nav-toggle {
        display: flex;
    }

    .nav-right {
        position: absolute;
        top: .2rem;
        right: 1rem;
        z-index: 10;
        margin-left: 0;
    }
    
    .footer-content {
        flex-direction: column;
        gap: 0.5rem; 
    }
}
</style>